
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 273 273","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M170.8 136.15l95-95A24.017 24.017 0 00248.851.13a24.022 24.022 0 00-16.991 7.02l-95 95-95-95a24.042 24.042 0 00-34 34l95 95-95 95a24.043 24.043 0 0034 34l95-95 95 95a24.042 24.042 0 1034-34l-95.06-95z"}})])
          )
        }
      }
    